// extracted by mini-css-extract-plugin
export default {"faq":"Faq_faq__RMOFX","title":"Faq_title__qqyIy","hr":"Faq_hr__Hikci","text":"Faq_text__RifkB","link":"Faq_link__oUssM","bold":"Faq_bold__hSVVF"};